import LocalizedStrings from 'localized-strings';

export default new LocalizedStrings({
  en: {
    costs: 'Find our more about card costs',
    description:
      'Your choice has been saved, and we will inform {firstName} {lastName}! Physical cards take about a week to arrive at your business address. Virtual cards are usable immediately.',
    fees: {
      all: 'You have been charged {orderFee}€ for shipping and you will then be charged €{monthlyFee}/month as soon as the card is activated.',
      onlyMonthly:
        'You will be charged €{monthlyFee}/month as soon as the card is activated.',
      onlyOrder: 'You have been charged €{orderFee} for shipping costs.',
    },
    title: 'Card request validated',
  },
  fr: {
    costs: 'En savoir plus sur les frais liés aux cartes',
    description:
      'Votre choix a été enregistré et nous allons informer {firstName} {lastName} ! Les cartes physiques mettent environ une semaine à arriver à votre adresse professionnelle. Les cartes virtuelles sont quant à elles utilisables immédiatement.',
    fees: {
      all: 'Vous avez été débité·e de {orderFee}\xa0€ pour les frais d’envoi. Vous serez ensuite débité·e de {monthlyFee}\xa0€ / mois dès la carte activée.',
      onlyMonthly:
        'Vous serez débité·e de {monthlyFee}\xa0€ / mois dès la carte activée.',
      onlyOrder:
        'Vous avez été débité·e de {orderFee}\xa0€ pour les frais d’envoi.',
    },
    title: 'Demande de carte validée',
  },
} as const);
